import { useHotkeys } from 'react-hotkeys-hook';

import { useCloseAssetModal } from '~/components/AssetModalV2/hooks/useCloseAssetModal';
import { useFullscreenContext } from '~/components/AssetModalV2/shared/context/FullscreenContext';

let _stopEscKeyPropagation = false;

export const stopEscKeyPropagationOnAssetDetailsModal = (nextValue: boolean) => {
  _stopEscKeyPropagation = nextValue;
};

export const useAssetModalEscKeyHandler = () => {
  const { closeAssetModal } = useCloseAssetModal({ trackLocation: 'esc-key' });
  const { isFullscreen } = useFullscreenContext();

  useHotkeys(
    'esc',
    () => {
      closeAssetModal();
    },
    {
      enabled: !isFullscreen && !_stopEscKeyPropagation,
    },
    [closeAssetModal],
  );
};
